module.exports = __webpack_public_path__ + "img/water-texture.1d2afab2.jpg";